import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

export type IncentiveTierType = {
  id?: number
  min_value: number
  max_value?: number
  amount: number
  sort_order: number
}

export type IncentiveItemType = {
  id: number
  name: string
  incentive_type: string
  incentive_code: string
  incentive_value?: number
  description?: string
  activity_type: string
  uom: string
  location_ids: number[]
  start_date: string
  end_date: string
  status: string
  tiers: IncentiveTierType[]
  created_by: string
  updated_by: string
  created_at: string
  updated_at: string
  upload_instruction?: string
}

export type GetIncentiveListParamsType = {
  cursor?: string
  name?: string
  activity_type?: string
  incentive_type?: string
  status?: string
  sort_by?: string
  sort_direction?: string
  page_size?: number
}

export type GetIncentiveListResponseType = {
  data: IncentiveItemType[]
  pagination: {
    next_cursor: string
    prev_cursor: string
  }
}

type ActivityType = 'DRIVER' | 'PICKER'
export type ActivityRoleType =
  | Uppercase<ActivityType>
  | Lowercase<ActivityType>
  | Capitalize<Lowercase<ActivityType>>

type IncentiveType = 'FIXED' | 'TIERING'
type IncentiveRoleType =
  | Uppercase<IncentiveType>
  | Lowercase<IncentiveType>
  | Capitalize<Lowercase<IncentiveType>>

export type PostAddEditIncentiveRequestType = {
  activity_type: ActivityRoleType
  end_date?: string
  id?: number
  description?: string
  incentive_type: IncentiveRoleType
  location_ids: number[]
  name: string
  start_date: string
  status: 'active' | 'inactive'
  tiers: IncentiveTierType[]
  uom: 'kilometer' | 'order' | 'item' | 'koli' | 'trip' | 'drop_point' | 'jam' | 'hari' | 'shift'
  upload_instruction?: string
  incentive_value?: number
}

type PostPutResponseType = {
  message: string
}

export const getIncentiveList = (params: GetIncentiveListParamsType) =>
  axiosInstanceApiGateway.Get<GetIncentiveListResponseType, true>({
    url: '/staff-management/internal/v1/order-incentive-setting',
    params,
  })

export const getIncentiveDetail = (id: number) =>
  axiosInstanceApiGateway.Get<IncentiveItemType>({
    url: `/staff-management/internal/v1/order-incentive-setting/${id}`,
  })

export const postAddEditIncentive = (data: PostAddEditIncentiveRequestType) =>
  axiosInstanceApiGateway.Post<PostPutResponseType, true>({
    url: `/staff-management/internal/v1/order-incentive-setting`,
    data,
  })
